import { React, useState, useEffect } from 'react';
import { useParams } from 'react-router';


import axios from 'axios';
import { Global } from '../../../Global';

import LoginOutData from '../../../helpers/LoginOutData';

import '../../../../assets/css/detalleRegistro.css';

import Loading from '../../../elementos/Loading';
import Error from '../../../elementos/Error';
import ButtonIcon from '../../../elementos/ButtonIcon';
import ConfirmDelete from '../../../elementos/ConfirmDelete';


import Grid from '@mui/material/Grid';

import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';

export default function Agendas() {

    const [estadoVista, setEstadoVista] = useState('loading');
    const [usuarios, setUsuarios] = useState({});

    const urlParams = useParams();



    useEffect(() => {

        axios.get(Global.url_api + 'mysql/usuarios/' + urlParams.id, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                setUsuarios(res.data.usuarios);
                setEstadoVista('cargado');

            })
            .catch((error) => {
                console.log(error?.response?.data);
                setEstadoVista('error')
            });

    }, [urlParams]);


    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error />)

    if (estadoVista === 'cargado')
        return (
            <>
                <Grid container>
                    <Grid item xs={12} md={6} style={{ marginBottom: '0px', fontSize: '1.2rem' }}>
                        <PersonIcon /> Usuarios
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div align="right">
                            {
                                LoginOutData.userHasPermiso(11) &&
                                <ButtonIcon
                                    variant="outlined"
                                    size="small"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    to={"/clientes/" + urlParams.id + "/app/usuario/nuevo"}
                                >
                                    Nuevo
                                </ButtonIcon>
                            }
                        </div>
                    </Grid>
                </Grid>
                <div className="tableContainer">
                    <table width="100%" className="formato1" cellSpacing="0" cellPadding="0">
                        <thead>
                            <tr>
                                <th align="center">Codigo</th>
                                <th align="left">Nombre</th>
                                <th align="left">Usuario</th>
                                <th align="center">Contraseña</th>
                                <th align="center">Controla</th>
                                <th align="center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usuarios.map((value, key) => {
                                return (
                                    <tr key={key} >
                                        <td align="center">{value.codigo}</td>
                                        <td align="left">{value.nombre}</td>
                                        <td align="left">{value.usuario}</td>
                                        <td align="center">*****</td>
                                        <td align="center">{value.controla}</td>
                                        <td align="center">
                                            {
                                                LoginOutData.userHasPermiso(11) &&
                                                <ButtonIcon
                                                    variant="outlined"
                                                    size="small"
                                                    color="neutral"
                                                    endIcon={<EditIcon />}
                                                    to={'/clientes/' + urlParams.id + '/app/usuario/editar/' + value.codigo}
                                                    marginRight
                                                />
                                            }
                                            {
                                                LoginOutData.userHasPermiso(11) &&
                                                <ConfirmDelete
                                                    variant="outlined"
                                                    size="small"
                                                    httpDelete={"mysql/usuarios/" + urlParams.id + "/" + value.codigo}
                                                    returnUrl={"/clientes/" + urlParams.id + "/app"}
                                                    soloIcono
                                                />
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>
        )

}